import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getPresetColorPalettes: {
    method: 'GET',
    url: `${configs.baseUrl}/api/preset/color-palettes`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getPresetColorPalettes = () => {
  return resource.getPresetColorPalettes()
}

export default {
  initResource,
  getPresetColorPalettes,
}
